<template>
  <div id="app">
    <el-container>
      <!-- 头部导航栏 -->
      <el-header class="header_container">
        <div class="header_wrapper">
          <div class="logo_wrapper" @click="logotap">
            <img
              src="@/assets/images/zaoyinggroup_logo.png"
              alt
              srcset
              class="zaoyinggroup_logo"
              draggable="false"
            />
          </div>
          <div class="header_title">
            <router-link
              v-for="(item, index) in headerMenu"
              :key="index"
              :to="item.url"
              class="menutitle"
            >
              <span :class="seletedindex == item.id ? 'active' : ''">
                {{ item.title }}
              </span>
            </router-link>
          </div>
        </div>
      </el-header>
    </el-container>
  </div>
</template>

<script>
export default {
  props: {
    seletedindex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      headerMenu: [
        {
          id: 0,
          title: "首页",
          url: "/",
        },
        {
          id: 1,
          title: "关于我们",
          url: "/aboutUs",
        },
        // {
        //   id: 2,
        //   title: "教育服务",
        //   url: "/"
        // },
        // {
        //   id: 3,
        //   title: "课程体系",
        //   url: "/course",
        // },
        {
          id: 7,
          title: "业务板块",
          url: "/business",
        },
        {
          id: 4,
          title: "新闻动态",
          url: "/newsInformation",
        },
        {
          id: 6,
          title: "人才招聘",
          url: "/recruitment",
        },
        {
          id: 5,
          title: "联系我们",
          url: "/contactUs",
        },
      ],
    };
  },
  methods: {
    logotap() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 40px;
}

.el-container {
  width: 100%;
}

.header_container {
  width: 100%;
  min-height: 75px !important;
  color: #000000;
  display: flex;
  align-items: center;
  padding: 0 !important;
  background-color: #fff;
}

.header_wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
}

.logo_wrapper {
  position: absolute;
  left: 20px;
  cursor: pointer;
}

.zaoyinggroup_logo {
  width: 140px;
  height: auto;
  display: block;
}

.header_title {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.menutitle {
  display: inline-block;
  padding: 0 10px;
  text-decoration: none;
  color: #000;
  font-size: 16px;
  line-height: 40px;
}

.menutitle:hover {
  color: #40a9ff;
}

.menutitle .active {
  font-weight: bold;
  color: #40a9ff;
}
</style>